import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Paper, Select, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress } from "@mui/material";
import React, { useState } from "react";
import { ArrowDropDown } from "@mui/icons-material";
import Image1 from "../../../components/Assets/images/iphone1.jpg";
import Image2 from "../../../components/Assets/images/iphone2.jpg";
import Image3 from "../../../components/Assets/images/iphone3.jpg";
import Search from "../../../components/common/search/Search"

const orders = [
    {
        title: "Item 1",
        imageUrl: Image1,
        status: "Available",
        description: "256 GB, Deep purple, Unlocked",
        price: "$900",
        category: "Electronic",
        shipping: "Cash on delivery",
        studentName: "John",
        orderStatus: "Delivered",
        date: "2025-03-15", 
        paymentStatus: "Paid",
        noOfItems: 1 
    },
    {
        title: "Item 2",
        imageUrl: Image2,
        status: "Sold",
        description: "128 GB, Black, Unlocked",
        price: "$700",
        category: "Mobile",
        shipping: "Free shipping",
        studentName: "David",
        orderStatus: "Returned",
        date: "2025-03-10",
        paymentStatus: "Pending",
        noOfItems: 2
    },
    {
        title: "Item 3",
        imageUrl: Image3,
        status: "Available",
        description: "512 GB, Gold, Unlocked",
        price: "$1200",
        category: "Laptop",
        shipping: "Cash on delivery",
        studentName: "Elisa",
        orderStatus: "Cancelled",
        date: "2025-03-12",
        paymentStatus: "Paid",
        noOfItems: 3
    },
    {
        title: "Item 4",
        imageUrl: Image1,
        status: "Available",
        description: "512 GB, Gold, Unlocked",
        price: "$1200",
        category: "Laptop",
        shipping: "Cash on delivery",
        studentName: "Elisa",
        orderStatus: "Cancelled",
        date: "2025-03-12",
        paymentStatus: "Paid",
        noOfItems: 4
    }
];

const OrdersTab = () => {
    const [mode, setMode] = useState(0); 
    const [selectedOption2, setSelectedOption2] = useState(""); 
    const [searchQuery, setSearchQuery] = useState(""); 

    const totalOrders = orders.length;
    const totalSpent = orders.reduce((sum, order) => sum + parseFloat(order.price.replace('$', '')), 0);

    const handleOption2Change = (event) => {
        setSelectedOption2(event.target.value);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const filterOrdersByStatus = () => {
        if (mode === 0) return orders; 
        return orders.filter((order) => {
            if (mode === 1) return order.orderStatus === "Delivered";
            if (mode === 2) return order.orderStatus === "Sent";
            if (mode === 3) return order.paymentStatus === "Pending";
            if (mode === 4) return order.orderStatus === "Cancelled";
            if (mode === 5) return order.orderStatus === "Returned";
            return false;
        });
    };

    const filterOrdersBySearch = (filteredOrders) => {
        if (!searchQuery) return filteredOrders; 
        return filteredOrders.filter((order) => 
            order.title.toLowerCase().includes(searchQuery.toLowerCase()) || 
            order.studentName.toLowerCase().includes(searchQuery.toLowerCase()) || 
            order.description.toLowerCase().includes(searchQuery.toLowerCase())
        );
    };

    const filteredOrders = filterOrdersBySearch(filterOrdersByStatus());

    return (
        <Grid container spacing={2} style={{ padding: '0px !important' }} className="max-h-[calc(100vh-210px)] overflow-y-auto">
            <Grid item xs={12} lg={4}>
                <Paper elevation={3} className="p-5 relative">
                    <Typography variant="subtitle1" color="textPrimary" className="!font-semibold">Orders Summary</Typography>
                    <div className="flex flex-col gap-2 mt-5">
                        <Grid item xs={12} sm={12} md={12}>
                            <FormControl fullWidth>
                                <InputLabel>Select Category</InputLabel>
                                <Select
                                    label="Option 2"
                                    value={selectedOption2}
                                    onChange={handleOption2Change}
                                    IconComponent={(props) => (
                                        <ArrowDropDown {...props} style={{ color: "#c942b1" }} />
                                    )}
                                >
                                    <MenuItem value={10}>Option 2A</MenuItem>
                                    <MenuItem value={20}>Option 2B</MenuItem>
                                    <MenuItem value={30}>Option 2C</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </div>

                    <Box mt={5} display="flex" flexDirection="column" gap={3}>
                        <Box display="flex" flexDirection="column">
                            <p className="text-gray-800 font-semibold">Total Orders</p>
                            <div className="flex items-center gap-5 mt-5">
                                <Box position="relative" display="inline-flex">
                                    <CircularProgress
                                        variant="determinate"
                                        value={100} 
                                        size={75}
                                        thickness={10}
                                        color="primary" 
                                    />
                                    <CircularProgress
                                        variant="determinate"
                                        value={(orders.length-1 / totalOrders) * 100}
                                        size={75}
                                        thickness={10}
                                        color="secondary" 
                                        sx={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                        }}
                                    />
                                </Box>
                                <p className="text-lg font-medium">No of Orders: {totalOrders}</p>
                            </div>
                        </Box>
                        <Box display="flex" flexDirection="column">
                            <p className="text-gray-800 font-semibold">Total Amount Spent</p>
                            <div className="flex items-center gap-5 mt-5">
                                <Box position="relative" display="inline-flex">
                                    <CircularProgress
                                        variant="determinate"
                                        value={100} 
                                        size={75}
                                        thickness={10}
                                        color="primary" 
                                    />
                                    <CircularProgress
                                        variant="determinate"
                                        value={(orders.length-2 / totalOrders) * 100}
                                        size={75}
                                        thickness={10}
                                        color="secondary" 
                                        sx={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                        }}
                                    />
                                </Box>
                                <p className="text-lg font-medium">${totalSpent.toFixed(2)}</p>
                            </div>
                        </Box>
                    </Box>
                </Paper>
            </Grid>

            <Grid item xs={12} lg={8} className="h-full">
                <Paper elevation={3} className="p-5 relative">
                    <Typography variant="subtitle1" color="textPrimary" className="!font-semibold">Orders List</Typography>
                    <div className="flex flex-wrap gap-4 my-5">
                        <Button variant={mode === 0 ? "contained" : "outlined"} color="secondary" disableElevation disableRipple onClick={() => setMode(0)} className="!w-fit px-2 py-1 hover:!bg-secondary hover:!text-white">All</Button>
                        <Button variant={mode === 1 ? "contained" : "outlined"} color="secondary" disableElevation disableRipple onClick={() => setMode(1)} className="!w-fit px-2 py-1 hover:!bg-secondary hover:!text-white">Completed</Button>
                        <Button variant={mode === 2 ? "contained" : "outlined"} color="secondary" disableElevation disableRipple onClick={() => setMode(2)} className="!w-fit px-2 py-1 hover:!bg-secondary hover:!text-white">Sent</Button>
                        <Button variant={mode === 3 ? "contained" : "outlined"} color="secondary" disableElevation disableRipple onClick={() => setMode(3)} className="!w-fit px-2 py-1 hover:!bg-secondary hover:!text-white">Unpaid</Button>
                        <Button variant={mode === 4 ? "contained" : "outlined"} color="secondary" disableElevation disableRipple onClick={() => setMode(4)} className="!w-fit px-2 py-1 hover:!bg-secondary hover:!text-white">Cancelled</Button>
                        <Button variant={mode === 5 ? "contained" : "outlined"} color="secondary" disableElevation disableRipple onClick={() => setMode(5)} className="!w-fit px-2 py-1 hover:!bg-secondary hover:!text-white">Returned</Button>
                    </div>
                    <div className="my-5">
                        <Search value={searchQuery} handleInputChange={handleSearchChange}/>
                    </div>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Orders</TableCell>
                                    <TableCell>Student Name</TableCell>
                                    <TableCell>Date</TableCell>
                                    <TableCell>Payment Status</TableCell>
                                    <TableCell>No of Items</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredOrders.map((order, index) => (
                                    <TableRow key={index}>
                                        <TableCell>
                                            <img src={order.imageUrl} alt={order.title} style={{ width: 50, height: 50, objectFit: "cover" }} />
                                        </TableCell>
                                        <TableCell>{order.studentName}</TableCell>
                                        <TableCell>{order.date}</TableCell>
                                        <TableCell>{order.paymentStatus}</TableCell>
                                        <TableCell>{order.noOfItems}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default OrdersTab;
